// extracted by mini-css-extract-plugin
module.exports = {"root":"PaneContainer_root__3_9jJ","horizontal":"PaneContainer_horizontal__1P4U_","vertical":"PaneContainer_vertical__3g5hM"};